import React, { Fragment, useState, useEffect } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    invoiceNoContainer: {
        flexDirection: 'row',
        marginTop: 36,
        justifyContent: 'center'
    },
    invoiceDateContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    invoiceDate: {
        fontSize: 22,
        fontStyle: 'bold',
        color: '#f8b64c'
    },
});

const InvoiceNo = ({ invoice }) => {
    const [name, setName] = useState(''); 

    useEffect(() => {
        const fullName = typeof window !== 'undefined' ? localStorage.getItem('name') || 'N/A' : 'N/A';
        setName(fullName);
    }, []);

    return (
        <Fragment>
            <View style={styles.invoiceNoContainer}>
                <Text style={styles.invoiceDate}>{name}</Text>
            </View>
        </Fragment>
    );
};

export default InvoiceNo;